(function () {
  var MIN_ORDER = 199;

  /* ─── Styles ─── */
  var style = document.createElement('style');
  style.textContent =
    '#bpmo-notice{' +
      'display:none;width:100%;box-sizing:border-box;' +
      'background:#fff8e1;border:1.5px solid #f0c040;' +
      'border-radius:10px;padding:12px 14px;margin-bottom:10px;' +
      'font-size:13px;color:#7a5200;text-align:center;line-height:1.5;' +
    '}' +
    '@keyframes bpmoShake{' +
      '0%,100%{transform:translateX(0)}' +
      '20%{transform:translateX(-5px)}' +
      '40%{transform:translateX(5px)}' +
      '60%{transform:translateX(-3px)}' +
      '80%{transform:translateX(3px)}' +
    '}';
  document.head.appendChild(style);

  /* ─── Auto-open cart drawer on add to cart ─── */
  function enableAutoOpen() {
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && !cartDrawer.hasAttribute('auto-open')) {
      cartDrawer.setAttribute('auto-open', '');
    }
  }

  /* Run immediately and on DOM ready */
  enableAutoOpen();
  document.addEventListener('DOMContentLoaded', enableAutoOpen);

  /* ─── Show notice above checkout button ─── */
  function showNotice(btn, total) {
    var notice = document.getElementById('bpmo-notice');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'bpmo-notice';
      var container =
        btn.closest('.cart__ctas') ||
        btn.closest('.cart-drawer__footer') ||
        btn.closest('form') ||
        btn.parentNode;
      container.parentNode.insertBefore(notice, container);
    }
    var remaining = (MIN_ORDER - total).toFixed(0);
    notice.textContent = 'Minimum order value: Rs.' + MIN_ORDER + ' (Add Rs.' + remaining + ' more)';
    notice.style.display = 'block';
    notice.style.animation = 'none';
    void notice.offsetHeight;
    notice.style.animation = 'bpmoShake 0.4s ease';
    clearTimeout(notice._timer);
    notice._timer = setTimeout(function () { notice.style.display = 'none'; }, 5000);
  }

  /* ─── Fetch live cart total ─── */
  function getCartTotal() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.total_price / 100; })
      .catch(function () { return 0; });
  }

  /* ─── Intercept checkout button clicks ─── */
  document.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    var checkoutBtn = null;
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (!el || !el.tagName) continue;
      if (
        el.id === 'checkout' ||
        (el.name === 'checkout' && el.tagName === 'BUTTON') ||
        (el.classList && el.classList.contains('cart__checkout-button'))
      ) {
        checkoutBtn = el;
        break;
      }
    }
    if (!checkoutBtn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    getCartTotal().then(function (total) {
      if (total < MIN_ORDER) {
        showNotice(checkoutBtn, total);
      } else {
        window.location.href = '/checkout';
      }
    });
  }, true);

})();
